import {AmsDataGridSortItem} from "./component/data-grid/AmsDataGrid";
import apiClient from "./web/ApiClient";

export interface ServerRequest {
  objectCode: string,
  filterConditions: FilterCondition[],
  projectedFields: string[],
  recordsPerPage: number,
  currentPage: number
  sortConditions: SortCondition[]
}

export interface Metadata {
  totalRecords: number,
  currentPage: number,
  recordsPerPage: number
}

export interface SortCondition {
  field: string;
  direction: string;
}

export interface ServerResponse {
  data: any[];
  meta: Metadata;
}

export const typeOperatorMap = new Map<string, string[]>([
  ['string', ['equals', 'contains']],
  ['number', ['equals']]
]);

export class FilterCondition {
  constructor(columnCode: string, operator: string, filterValue: string) {
    this.columnCode = columnCode;
    this.operator = operator;
    this.filterValue = filterValue;
  }

  columnCode: string;
  operator: string;
  filterValue: string;
}

export async function requestQuery(objectCode: string,
                                   filterConditions: FilterCondition[],
                                   projectedFields: string[],
                                   sortConditions: SortCondition[],
                                   successCallback: any, pageNumber: number, pageSize: number) {
  const request: ServerRequest = {
    objectCode: objectCode,
    filterConditions: filterConditions,
    projectedFields: projectedFields,
    recordsPerPage: pageSize,
    currentPage: pageNumber,
    sortConditions: sortConditions
  }

  await apiClient.post("/ams/api/v1/queries", request)
  .then(response => {
    successCallback(response);
  })
}

export function getApiSort(sortModel?: readonly AmsDataGridSortItem[]): SortCondition[] {
  if (!sortModel) {
    return [];
  }
  return sortModel.map(item => {
    return {field: item.field, direction: `${item.direction}`}
  });
}

const operators = new Map<string, string>([
  ['equals', 'eq'],
  ['contains', 'like']
]);

export const translateToQueryApiOperator = (operator: string) => {
  return operators.get(operator)
}


